var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppTypePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17532",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12967",
    d: "M10.406 13.246c.964.965 2.186 1.58 2.913.856l.176-.176a.531.531 0 00-.071-.813l-.561-.392a.536.536 0 00-.684.057l-.2.2a4.272 4.272 0 01-.718-.584h0a4.255 4.255 0 01-.584-.718l.2-.2a.536.536 0 00.058-.687c-.144-.2-.273-.389-.392-.561a.531.531 0 00-.813-.071l-.176.176c-.723.727-.109 1.948.856 2.913"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12958",
    d: "M12.666 8V5.219a1.334 1.334 0 00-.391-.943L10.39 2.391A1.334 1.334 0 009.448 2H4.666a1.333 1.333 0 00-1.333 1.333v9.333A1.333 1.333 0 004.666 14h2.667"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12959",
    d: "M5.333 6h5.333"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12960",
    d: "M5.333 8h5.333"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12961",
    d: "M5.333 10h1.333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12964",
    d: "M0 0h16v16H0z",
    fill: "none"
  })));
}
export default SvgAppTypePhone;


//////////////////
// WEBPACK FOOTER
// ./src/icons/appType-Phone.svg
// module id = 451
// module chunks = 11